import React, { useEffect, useState } from "react";

const ExistingModal = ({ data }) => {
  const [online, setOnline] = useState(navigator.onLine);

  return (
    <>
      <div
        className="modal fade"
        id="scrollableModal"
        tabindex="-1"
        aria-labelledby="scrollableModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content" style={{ height: "80%" }}>
            <div class="modal-header py-4">
              <h5 class="modal-title" id="scrollableModalLabel">
                Supported Countries
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeExistingModal"
              ></button>
            </div>
            <div className="modal-body p-0">
              <ul class="list-group">
                {data?.map((item, index) => (
                  <li key={index} className="list-group-item py-3">
                    {item.label}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExistingModal;
